import { Box, Typography } from '@mui/material'
import { memo } from 'react'
import IconifyIcon from '../icon'

const CandidateInviteMessage = ({
  message,
  isLastMessage,
  onAwaitingAprrovalClick
}) => {
  const candidateData = message?.confirmation?.data || {}

  if (!isLastMessage) {
    return (
      <Box className="chatbot-message__markdown">
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            mb: 0.75
          }}
        >
          <IconifyIcon
            icon="mdi:check-circle"
            fontSize="15px"
            style={{
              color: 'var(--success-main, #4caf50)',
              flexShrink: 0
            }}
          />
          <Typography
            variant="caption"
            sx={{ fontWeight: 600, color: 'text.primary' }}
          >
            Candidate Details
          </Typography>
        </Box>

        {/* Fields */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4 }}>
          {[
            { label: 'Name', value: candidateData?.name },
            { label: 'Email', value: candidateData?.email },
            { label: 'Phone', value: candidateData?.phoneNumber }
          ].map(({ label, value }) =>
            value ? (
              <Box
                key={label}
                sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.secondary',
                    minWidth: 36,
                    flexShrink: 0
                  }}
                >
                  {`${label}:`}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.primary',
                    fontWeight: 700,
                    wordBreak: 'break-all'
                  }}
                >
                  {value}
                </Typography>
              </Box>
            ) : null
          )}
        </Box>
      </Box>
    )
  }

  // Awaiting approval
  return (
    <Box className="chatbot-message__markdown">
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          mb: 0.75
        }}
      >
        <IconifyIcon
          icon="mdi:clock-outline"
          fontSize="15px"
          style={{ color: 'var(--primary-main)', flexShrink: 0 }}
        />
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: 'var(--primary-main)' }}
        >
          Awaiting Your Approval
        </Typography>
      </Box>

      {/* Fields (if prefilled) */}
      {(candidateData?.name || candidateData?.email) && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.4,
            mb: 1
          }}
        >
          {[
            { label: 'Name', value: candidateData?.name },
            { label: 'Email', value: candidateData?.email },
            { label: 'Phone', value: candidateData?.phoneNumber }
          ].map(({ label, value }) =>
            value ? (
              <Box
                key={label}
                sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.secondary',
                    minWidth: 36,
                    flexShrink: 0
                  }}
                >
                  {label}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.primary',
                    fontWeight: 500,
                    wordBreak: 'break-all'
                  }}
                >
                  {value}
                </Typography>
              </Box>
            ) : null
          )}
        </Box>
      )}

      {/* Action */}
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          display: 'block',
          mb: 1,
          lineHeight: 1.5
        }}
      >
        Please confirm the details in the modal. If it's not visible, click
        below.
      </Typography>
      <Box
        component="button"
        onClick={() => onAwaitingAprrovalClick(message)}
        sx={{
          backgroundColor: 'var(--primary-main)',
          color: 'var(--primary-contrastText)',
          border: 'none',
          padding: '4px 0',
          width: '100%',
          cursor: 'pointer',
          borderRadius: 1,
          fontWeight: 600,
          fontSize: '12px',
          boxShadow: 'none'
        }}
      >
        Provide Consent
      </Box>
    </Box>
  )
}

export default memo(CandidateInviteMessage)
